import React from "react";
import Menu from "@mui/material/Menu";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import { keysObject, valuesObject } from "../../../../utils/utils";
import ImageTag from "../../../slidebox/components/SlideItems/ImageTag";
import More from "../../../../assets/icons/more.svg";

const DashboardTableMoreOption = ({
  index,
  selectedRowIndex,
  setSelectedRowIndex,
  setActivateOrDeactivateUserData,
  setChangeRoleType,
  userList,
  setActivateOrDeactivateUser,
  setUserRole,
  resendInvitation,
  setDeleteUserInvitation,
  loggedUserDetails,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setSelectedRowIndex(index);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e, clearSelectedRowIndex) => {
    clearSelectedRowIndex === "backdropClick" && setSelectedRowIndex("");
    setAnchorEl(null);
  };

  let expired = false;
  if (userList.invitationExpiryAt) {
    expired = new Date() >= new Date(userList.invitationExpiryAt);
  }

  const ButtonAttributes = {
    ...(userList.status === "active" && loggedUserDetails && loggedUserDetails.roleName === "System Administrator" ? {
          Change_account_type: {
            onClick: () => {
              setUserRole(userList);
              setChangeRoleType(true);
              handleClose(true);
            },
          },
        }
      : []),
    ...(userList.status !== "invited" && loggedUserDetails.roleName === "System Administrator"
      ? {
          [`${
            userList.status === "active"
              ? "Deactivate_account"
              : "Activate_account"
          }`]: {
            onClick: () => {
              setActivateOrDeactivateUserData(userList);
              setActivateOrDeactivateUser(true);
              handleClose(true);
            },
          },
        }
      : []),
    ...(userList.status === "invited" && expired
      ? {
          Resend_invitation: {
            onClick: () => {
              resendInvitation(userList);
              handleClose(true);
              setSelectedRowIndex("");
            },
          },
        }
      : []),
    ...(userList.status === "invited"
      ? {
          Revoke_invitation: {
            onClick: () => {
              setDeleteUserInvitation(userList);
              handleClose(true);
            },
          },
        }
      : []),
  };

  return valuesObject(ButtonAttributes).length !== 0 && (
    <div>
      <ImageTag
        aria-controls="customized-menu"
        aria-haspopup="true"
        onClick={handleClick}
        className={`user-details-more-icon 
                ${selectedRowIndex === index ? "active" : ""}`}
        src={More}
      />
      {Boolean(anchorEl) && (
        <Menu
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          style={{ pointerEvents: 'none' }}
          elevation={5}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{ sx: { border: "1px solid #d3d4d5" } }}
        >
              {valuesObject(ButtonAttributes).map(({ ...all }, index) => (
                <ClickAwayListener onClickAway={() => {
                  if(Boolean(anchorEl)) {
                    setSelectedRowIndex("");
                    setAnchorEl(null);
                  }
                }}>
                  <MenuItem
                    style={{ pointerEvents: 'auto' }}
                    className="dropdown-li"
                    {...all}
                    key={index}
                    sx={{ "&:focus": { backgroundColor: "primary.main", "& .MuiListItemIcon-root, & .MuiListItemText-primary": { color: "common.white" } } }}
                  >
                    <ListItemText
                      primary={keysObject(ButtonAttributes)[index].replace(/_/g, " ")}
                    />
                  </MenuItem>
                </ClickAwayListener>
              ))}
        </Menu>
      )}
    </div>
  );
};

export default DashboardTableMoreOption;
